import { Component, OnInit, ViewChild, TemplateRef, ElementRef, NgZone, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, NgForm } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from 'src/app/common-methods/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AgentEntryMasterService } from 'src/app/common-methods/services/agent-entry-master.service';
import { CommonAlertsComponent } from 'src/app/common-methods/common-alerts/common-alerts.component';
import { MatDialog } from '@angular/material';
import { CommonService } from 'src/app/common-methods/services/common.service';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'app-digitaladdressverfication',
  templateUrl: './digitaladdressverfication.component.html',
  styleUrls: ['./digitaladdressverfication.component.css']
})
export class DigitaladdressverficationComponent implements OnInit {
  signPhotoName: any;
  candidatePhotoName: any;
  idProffName: any;
  Housename: any;
  uploadHouse: any;
  idProff: any;
  canidatePhoto: any;
  signPhoto: any;
  Clinetdata: any
  clientName: any;
  candidateName: any;
  verifiationId: any;
  addressForm: FormGroup;
  document = []
  addressType
  relationshipTypes: any[] = []
  applicainDetails
  ScrenningComid: any
  headerText = '';
  bodyText = '';
  imageChangedEvent
  srcElementVal
  action
  maxDate = new Date()
  minDate = new Date()
  // Latest selectable date for the stay period (From and To) - a candidate cannot pick a future date.
  today = new Date()
  @ViewChild('sucessAlert', null) sucessAlert: TemplateRef<any>;
  @ViewChild(ImageCropperComponent, null) imageCropper: ImageCropperComponent;

  @ViewChild('video', { static: false }) video: ElementRef;
  isCameraOpen = false;
  capturedImage: string | null = null;
  locationLoading: boolean = false;
  locationError: string = '';
  private stream: MediaStream;

  // Door photo: camera-only capture (was a plain <input type="file">, which let the candidate pick an
  // existing gallery photo instead of taking a live one). Kept as its own video/stream/state - not a
  // shared method with the selfie camera - so a candidate could in principle have either camera's
  // preview open without the two stepping on each other's <video> element.
  @ViewChild('doorVideo', { static: false }) doorVideo: ElementRef;
  isDoorCameraOpen = false;
  capturedDoorImage: string | null = null;
  private doorStream: MediaStream;
  doorFacingMode: 'environment' | 'user' = 'environment';   // back camera by default (see openDoorCamera)
  hasMultipleCameras = false;

  // ── Preview (review everything before Submit) ──
  @ViewChild('previewDialog', null) previewDialog: TemplateRef<any>;
  @ViewChild('addressBlock', { static: false }) addressBlock: ElementRef;
  previewFields: Array<{ label: string; value: string }> = [];
  previewAddress: Array<{ label: string; value: string }> = [];
  previewDocs: Array<{ label: string; src: string; name: string; note: string }> = [];
  private previewObjectUrls: string[] = [];
  // DAV: permanent address shows a Self/Others relationship dropdown; current address is locked to Self.
  isPermanentAddress = true;
  // DAV: driven by the client's "verification Enable" setting (663) — when true the selfie is mandatory
  // and the "refuse photo" option is hidden.
  verificationEnable = false;

  // CTS-AC-2710: the reviewer's rejection remarks, shown as a banner so the candidate knows why the case
  // was sent back. Empty when the case was never rejected (or was rejected then already resubmitted).
  rejectReason = '';

  // CTS-AC-2710: filenames from the candidate's previous submission, shown as "already uploaded: X" per
  // slot so a reopened case doesn't force re-uploading documents that were never the problem. Cleared the
  // moment the candidate captures a fresh file for that slot (see captureImage/uploadIdProff/
  // captureDoorImage), since the new capture then takes over for submission.
  previousSelfieFileName = '';
  previousIdProofFileName = '';
  previousDoorPhotoFileName = '';
  // data: URIs for the same three, so the reopened page can actually show the photo instead of only its
  // name - null when the previous upload wasn't a displayable image (e.g. a PDF ID proof).
  previousSelfieUrl = '';
  previousIdProofUrl = '';
  previousDoorPhotoUrl = '';

  // DAV: the "valid ID proofs" note under the ID Proof upload is a CTS-only requirement. This endpoint
  // carries no CTS flag (the reports get one from the CTS client setting), so it is matched on the client
  // name - the same approach as the iCOVER grace window in ngOnInit. Matched loosely so
  // "Cognizant Technology Solutions India Pvt Ltd" and any similar spelling of the name still qualify.
  get isCtsClient(): boolean {
    return (this.clientName || '').toLowerCase().indexOf('cognizant') !== -1;
  }

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private agentEntryMasterService: AgentEntryMasterService,
    private dialog: MatDialog,
    private common: CommonService,
    private message: MessageService,
    private zone: NgZone,
    private cdr: ChangeDetectorRef
  ) { }
  // Feeds <app-address>: pushing the data-entry address here runs its country -> state -> district ->
  address1 = new BehaviorSubject<any>(null);

  ngOnInit() {
    this.getUrl();
    // FIX 1: Initialize the form group IMMEDIATELY so HTML doesn't crash
    // The form MUST exist before the detail APIs are called: getDetails() patches the form (prefilled
    // address, and 'Self' for a current address). Calling it first left those writes with no form to land
    // on whenever the response arrived before the group was built.
    this.addressForm = this.formBuilder.group({
      verificationId: new FormControl(null),
      clientName: new FormControl(null),
      candidateName: new FormControl(null),
      addressType: new FormControl(null, Validators.required),
      latitude: new FormControl(null),
      longitude: new FormControl(null),
      distanceKm: new FormControl(null),
      respondentName: new FormControl('', Validators.required),
      RelationshipWithTheCandidate: new FormControl(null),
      landmark: new FormControl(null),
      alternativeContactNumber: new FormControl(null, [Validators.required, Validators.minLength(10)]),
      ownershipDetails: new FormControl(null),
      fromDate: new FormControl(null, Validators.required),
      toDate: new FormControl(null, Validators.required),
      addressuser: new FormControl(),
      clientId: new FormControl(),
      candidateId: new FormControl(),
      FieldExecutiveAddressFlag: new FormControl(false),

      // DAV: email optional; relationship free-text spec (when Others); name of the person completing
      // the process; and photo-refusal capture (refused flag + mandatory reason).
      emailAddress: new FormControl('', [Validators.email]),
      RelationshipSpecification: new FormControl(''),
      completedByName: new FormControl('', Validators.required),
      isPhotoRefused: new FormControl(false),
      photoRefusalReason: new FormControl(''),

      address: new FormGroup({
        addressId: new FormControl(0),
        addLine1: new FormControl('', Validators.required),
        addLine2: new FormControl(''),
        addLine3: new FormControl(''),
        cityId: new FormControl(''),
        districtId: new FormControl(''),
        stateId: new FormControl('', Validators.required),
        countryId: new FormControl('', Validators.required),
        postalCode: new FormControl('', Validators.required),
        active: new FormControl(true),
        locationId: new FormControl(),
        country: new FormControl(),
        city: new FormControl(),
        district: new FormControl(),
        state: new FormControl(),
        place: new FormControl(),
      }),
    });
    // Start fast loading sequence
    this.getLocation(true);
    this.authService.getUrlExpiryDate(this.ScrenningComid).subscribe(data => {
      // DAV: invitation cancelled via "Cancel Invite" (MIS report) -> the link must land on URL expired.
      if (data && (data.cancelInvite === true || data.cancelInviteFlag === true || data.cancelFlag === true)) {
        this.router.navigate(['/urlexpired']);
        return;
      }
      const currentDate = new Date();
      const expiry = this.common.getTimezoneOffset(data.expiryDate, false);
      const diffInHours = (expiry != null) ? (currentDate.getTime() - expiry.getTime()) / (1000 * 60 * 60) : null;
      if (data.clientName === 'iCOVER Services' && diffInHours > 72) {
        this.router.navigate(['/urlexpired']);
      } else {
        this.getDetails(this.ScrenningComid);
        this.GetAddressDetails();
      }
    });

  }

  uploaCandidate(fileInput: FileList) {

    const img = fileInput[0].name.split('.').pop();
    if (img === 'png' || img === 'PNG' || img === 'jpg' || img === 'JPG' || img === 'jpeg' || img === 'gif' || img === 'psd' || img === 'bmp') {
      this.candidatePhotoName = fileInput[0].name
      for (let _files in fileInput) {
        if (_files != "length" && _files != "item") {
          this.canidatePhoto = fileInput.item(Number(_files));
        }
      }

    }
    else {
      this.commonAlert()
    }
  }

  uploadSign(fileInput: FileList) {

    const img = fileInput[0].name.split('.').pop();
    if (img === 'png' || img === 'PNG' || img === 'jpg' || img === 'JPG' || img === 'jpeg' || img === 'gif' || img === 'psd' || img === 'bmp') {
      this.signPhotoName = fileInput[0].name
      for (let _files in fileInput) {
        if (_files != "length" && _files != "item") {
          this.signPhoto = fileInput.item(Number(_files));
        }
      }
    }
    else {
      this.commonAlert()
    }
  }
  uploadIdProff(fileInput: FileList) {

    const img = fileInput[0].name.split('.').pop();
    if (img === 'png' || img === 'PNG' || img === 'jpg' || img === 'JPG' || img === 'jpeg' || img === 'gif' || img === 'psd' || img === 'bmp') {
      this.idProffName = fileInput[0].name
      // CTS-AC-2710: a fresh capture replaces the "previously uploaded" indicator for this slot.
      this.previousIdProofFileName = '';
      this.previousIdProofUrl = '';
      for (let _files in fileInput) {
        if (_files != "length" && _files != "item") {
          this.idProff = fileInput.item(Number(_files));
        }
      }
    }
    else {
      this.commonAlert()
    }
  }

  removeImage(name) {
    if (name === 'candidatePhotoName') {
      this.canidatePhoto = ''
      this.candidatePhotoName = ''
      this.capturedImage = null;
    }
    // else if (name === 'signPhotoName') {
    //   this.signPhoto = ''
    //   this.signPhotoName = ''
    // }
    else if (name === 'Housename') {
      this.uploadHouse = ''
      this.Housename = ''
      this.capturedDoorImage = null;
    }
    else {
      this.idProff = ''
      this.idProffName = ''
    }

  }

  addressSumbit() {
    if (!this.validateBeforeSubmit()) { return; }
    const isPhotoRefusedCtrl = this.addressForm.get('isPhotoRefused');
    const isPhotoRefused = isPhotoRefusedCtrl ? isPhotoRefusedCtrl.value : false;
    this.applicainDetails = {
      ...this.addressForm.value,
      // JSON.stringify() below calls Date.toISOString() on fromDate/toDate, which converts the
      // LOCAL-midnight Date the calendar picker builds (new Date(year, month, date)) to UTC - for IST
      // (UTC+5:30) that always lands on the PREVIOUS day (e.g. 1 Aug 00:00 IST -> 2026-07-31T18:30:00Z),
      // so the date the candidate picked quietly arrived at the backend one day early. Re-anchor to UTC
      // noon on the SAME calendar day first, so the stringified date part always matches what was
      // actually picked, regardless of the browser's timezone.
      fromDate: this.toUtcNoon(this.addressForm.value.fromDate),
      toDate: this.toUtcNoon(this.addressForm.value.toDate),
      ...this.Clinetdata
    };
    const formData = new FormData();
    formData.append('AddressForm', JSON.stringify(this.applicainDetails));

    // CTS-AC-2710: named per-slot fields instead of position (Document_0/1/2), which broke down as soon
    // as refusal could drop the selfie from the count - the backend now reads Selfie/IdProof/DoorPhoto
    // by name (see DigitalAddressVerification). Only append a slot that has a FRESH capture; leaving a
    // slot out tells the backend to keep whatever was uploaded there last time (reopened-case reuse).
    if (!isPhotoRefused && this.canidatePhoto) {
      formData.append('Selfie', this.canidatePhoto);
    }
    if (this.idProff) {
      formData.append('IdProof', this.idProff);
    }
    if (this.uploadHouse) {
      formData.append('DoorPhoto', this.uploadHouse);
    }
    this.authService.addDigitialAddressVerificaton(formData).subscribe(redata => {
      if (redata != null || redata != 0) {
        const Bodytext = 'Thank you for submitting the address details for background verification!You will not be able to edit any detail or upload any document after Clicking' + '"Submit"';
        this.alert(Bodytext)
      }
    })
  }

  // Every check Submit makes before posting - shared with Preview, so the preview only ever shows a submission
  // that would actually be accepted. Shows the relevant warning and returns false on the first failure.
  private validateBeforeSubmit(): boolean {
    if (this.addressForm.invalid) {
      this.addressForm.markAllAsTouched();
      return false;
    }
    const isPhotoRefusedCtrl = this.addressForm.get('isPhotoRefused');
    // When the client mandates the selfie (verificationEnable = setting 663), refusal is not
    // allowed — force the flag off so the photo is always required.
    if (this.verificationEnable && isPhotoRefusedCtrl) {
      isPhotoRefusedCtrl.setValue(false);
    }
    // Selfie is mandatory when the client has the "verification Enable" setting (663) on. A previously-
    // uploaded selfie (CTS-AC-2710: reopened case) satisfies this the same as a fresh capture - the
    // candidate only needs to redo the slot that was actually the problem.
    if (this.verificationEnable && !this.canidatePhoto && !this.previousSelfieFileName) {
      this.showTopCenter('warn', 'Failure Message', 'Please upload candidate photo/selfie');
      return false;
    }
    if (!this.idProff && !this.previousIdProofFileName) {
      this.showTopCenter('warn', 'Failure Message', 'Please upload ID proof');
      return false;
    }
    if (!this.uploadHouse && !this.previousDoorPhotoFileName) {
      this.showTopCenter('warn', 'Failure Message', 'Please upload door photo');
      return false;
    }
    const latCtrl = this.addressForm.get('latitude');
    const lngCtrl = this.addressForm.get('longitude');
    if (!latCtrl || !latCtrl.value || !lngCtrl || !lngCtrl.value) {
      this.showTopCenter('warn', 'Failure Message', 'Please allow access to your current location');
      return false;
    }
    return true;
  }

  // ── Preview: a read-only summary of everything that will be submitted, with Edit / Confirm & Submit. ──
  openPreview() {
    if (!this.validateBeforeSubmit()) { return; }
    const v = this.addressForm.value;
    const text = (x: any) => (x === null || x === undefined || String(x).trim() === '') ? '-' : String(x).trim();

    let relationship = '';
    if (!this.isPermanentAddress) {
      relationship = 'Self';
    } else if (this.isCtsClient) {
      relationship = v.RelationshipWithTheCandidate || '';
      if (relationship === 'Others' && v.RelationshipSpecification) {
        relationship += ' - ' + v.RelationshipSpecification;
      }
    }
    const status = (this.addressType || []).filter((t: any) => t.lookUpId === v.addressType)[0];

    this.previewFields = [
      { label: 'Verification ID', value: text(this.verifiationId) },
      { label: 'Candidate Name', value: text(this.candidateName) },
      { label: 'Client Name', value: text(this.clientName) },
      { label: 'Latitude', value: text(v.latitude) },
      { label: 'Longitude', value: text(v.longitude) },
      { label: 'Respondent Name', value: text(v.respondentName) },
      { label: 'Relationship with the Candidate', value: text(relationship) },
      { label: 'Phone Number', value: text(v.alternativeContactNumber) },
      { label: 'Email Address', value: text(v.emailAddress) },
      { label: 'Building / Address Status', value: text(status ? status.lookUpName : '') },
      { label: 'Completed By (Name)', value: text(v.completedByName) },
      { label: 'From Date', value: text(this.previewDate(v.fromDate)) },
      { label: 'To Date', value: text(this.previewDate(v.toDate)) }
    ];

    // Address: read back exactly what the candidate sees in each <app-address> field (its controls hold ids
    // for the country/state/district lookups, so the on-screen text is the only readable form of them).
    this.previewAddress = [];
    const block: HTMLElement = this.addressBlock && this.addressBlock.nativeElement;
    if (block) {
      const fields = block.querySelectorAll('mat-form-field');
      for (let i = 0; i < fields.length; i++) {
        const field = fields[i] as HTMLElement;
        const label = field.querySelector('mat-label');
        const input = field.querySelector('input, textarea') as HTMLInputElement;
        const value = input ? (input.value || '').trim() : '';
        if (label && value) {
          this.previewAddress.push({ label: (label.textContent || '').replace('*', '').trim(), value });
        }
      }
    }

    this.revokePreviewUrls();
    const refused = !this.verificationEnable && !!v.isPhotoRefused;
    this.previewDocs = [
      refused
        ? { label: 'Candidate Photo / Selfie', src: '', name: '', note: 'Refused: ' + text(v.photoRefusalReason) }
        : {
          label: 'Candidate Photo / Selfie', src: this.capturedImage || this.previousSelfieUrl || '',
          name: this.candidatePhotoName || this.previousSelfieFileName || '',
          note: (this.capturedImage || this.previousSelfieUrl) ? '' : 'Not provided'
        },
      {
        label: 'Door Photo', src: this.capturedDoorImage || this.previousDoorPhotoUrl || '',
        name: this.Housename || this.previousDoorPhotoFileName || '', note: ''
      },
      {
        label: 'ID Proof', src: this.idProofPreviewUrl() || this.previousIdProofUrl || '',
        name: this.idProffName || this.previousIdProofFileName || '', note: ''
      }
    ];

    const ref = this.dialog.open(this.previewDialog, {
      width: '900px', maxWidth: '95vw', maxHeight: '90vh', autoFocus: false, panelClass: 'dav-preview-panel'
    });
    ref.afterClosed().subscribe(result => {
      this.revokePreviewUrls();
      if (result === 'submit') { this.addressSumbit(); }
    });
  }

  private previewDate(d: any): string {
    if (!d) { return ''; }
    const date = new Date(d);
    return isNaN(date.getTime()) ? String(d)
      : date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  }

  // A freshly picked ID proof is a File, not a data URL - give the preview a temporary URL for it.
  private idProofPreviewUrl(): string {
    if (this.idProff && this.idProff instanceof Blob && (window as any).URL) {
      const url = URL.createObjectURL(this.idProff);
      this.previewObjectUrls.push(url);
      return url;
    }
    return '';
  }

  private revokePreviewUrls() {
    this.previewObjectUrls.forEach(u => URL.revokeObjectURL(u));
    this.previewObjectUrls = [];
  }

  GetAddressDetails() {
    this.authService.getDigitialAddressType().subscribe(res => {
      this.addressType = res.typeOfAddress;
      // DAV: Self / Others options for the permanent-address relationship dropdown.
      this.relationshipTypes = res.relationshipTypes || [];
    });
  }
  // True when QC rejected the case and the invitation was resent - the candidate has to submit again, so the
  // earlier submission must NOT block the form. Any of these from the API means "re-opened":
  //   - allowResubmit / isResubmit = true (explicit signal)
  //   - status back to 'Pending'  -> RenewDavInvitation resets it that way after a reject
  //   - status still 'Rejected'   -> kept as a fallback in case the backend does not reset it; a rejected
  //     case always needs a fresh candidate submission, so the form must open either way.
  private isReopenedForResubmit(data: any): boolean {
    if (!data) { return false; }
    if (data.allowResubmit === true || data.isResubmit === true) { return true; }
    const status = (data.davStatus || data.status || '').toString().trim().toLowerCase();
    return status === 'pending' || status === 'rejected';
  }

  getDetails(dat) {
    this.authService.getDigitialAddressverification(this.ScrenningComid).subscribe(data => {
      if (data === null || data === 0 || data === undefined) {
        this.showTopCenter('warn', 'Failure Message', 'User Not Found');
        this.router.navigate(['/privacy'])
      }
      // Reject -> Resend Link flow: when QC rejects a case and the invitation is resent, the candidate MUST
      // be able to fill the form again. The API still reports the earlier submission, so "already submitted"
      // is only final when the case has NOT been re-opened for resubmission (status back to Pending, or an
      // explicit allowResubmit/isResubmit flag).
      else if (data.alredaySubmit === "Already submitted the address" && !this.isReopenedForResubmit(data)) {
        const Bodytext = 'The candidate already submitted the digital address verification Process';
        this.alert(Bodytext)
      }
      else {
        this.verifiationId = data.verifiactionId
        this.candidateName = data.candidateName
        this.clientName = data.clientName
        this.verificationEnable = data.verificationEnable === true;
        this.rejectReason = data.rejectReason || '';
        // Previous address behaves like Permanent (Self/Others dropdown) - only CURRENT locks to Self.
        // Backend sends isPermanentAddress=false for Previous too, so it needs its own flag.
        this.isPermanentAddress = data.isPermanentAddress !== false || data.isPreviousAddress === true;
        // this.addressForm.get('addressuser').setValue(data.address.addLine1 ? '/' : '' + data.address.district ? ',' : ''
        //   + data.address.city ? '-' : '' + data.address.postalCode + ' ' + data.address.state ? ',' : '' + data.address.country)
        this.Clinetdata = {
          ClientId: data.clientId, CandidateId: data.candidateId, VerificationId: data.screeningComId,
          DavaddressId: data.address ? data.address.addressId : null
        }
        if (this.addressForm) {
          if (data.addTypeLookupId) {
            this.addressForm.get('addressType').setValue(data.addTypeLookupId);
          }
          if (data.phoneNumber) {
            this.addressForm.get('alternativeContactNumber').setValue(data.phoneNumber);
          }
          // CTS-AC-2710: prefill everything the candidate typed last time, so a reopened case (reject ->
          // resend) only requires fixing whatever was actually wrong instead of retyping the whole form.
          if (data.respondentName) {
            this.addressForm.get('respondentName').setValue(data.respondentName);
          }
          if (data.relationshipWithTheCandidate) {
            this.addressForm.get('RelationshipWithTheCandidate').setValue(data.relationshipWithTheCandidate);
            // setValue() alone skips onRelationshipChange's side effect of making "Specify Relationship"
            // required when the prefilled value is "Others" - go through the same handler a manual
            // dropdown selection would use (mirrors the selfieRefused prefill just below).
            this.onRelationshipChange(data.relationshipWithTheCandidate);
          }
          if (data.relationshipOtherText) {
            this.addressForm.get('RelationshipSpecification').setValue(data.relationshipOtherText);
          }
          if (data.respondentEmail) {
            this.addressForm.get('emailAddress').setValue(data.respondentEmail);
          }
          if (data.completedByName) {
            this.addressForm.get('completedByName').setValue(data.completedByName);
          }
          if (data.stayFromDate) {
            this.addressForm.get('fromDate').setValue(new Date(data.stayFromDate));
          }
          if (data.stayToDate) {
            this.addressForm.get('toDate').setValue(new Date(data.stayToDate));
          }
          if (data.selfieRefused) {
            // setValue() alone would skip onPhotoRefuseChange's side effect of making the refusal reason
            // required - go through the same handler a manual checkbox click would use.
            this.addressForm.get('isPhotoRefused').setValue(true);
            this.onPhotoRefuseChange({ checked: true });
            if (data.selfieRefusalReason) {
              this.addressForm.get('photoRefusalReason').setValue(data.selfieRefusalReason);
            }
          }
          // "Already uploaded: X" indicators - satisfy the mandatory-document checks in addressSumbit()
          // until the candidate captures a fresh file for that slot (see uploaCandidate/uploadIdProff/
          // captureDoorImage, which clear the matching indicator below).
          this.previousSelfieFileName = data.previousSelfieFileName || '';
          this.previousIdProofFileName = data.previousIdProofFileName || '';
          this.previousDoorPhotoFileName = data.previousDoorPhotoFileName || '';
          this.previousSelfieUrl = data.previousSelfieUrl || '';
          this.previousIdProofUrl = data.previousIdProofUrl || '';
          this.previousDoorPhotoUrl = data.previousDoorPhotoUrl || '';
          // Item 7: auto-fill the candidate's address with the address mentioned in the initiation email / VTS
          // (the data-entry address the backend now returns in data.address). Editable — the candidate can
          // still correct it before submitting.
          if (data.address && this.addressForm.get('address')) {
            this.addressForm.get('address').patchValue({
              // addressId MUST stay 0 - only the address TEXT is prefilled from data entry. Sending the
              // data-entry addressId back made the backend UPDATE that same row on submit, so the candidate's
              // edit overwrote the data-entry address (both rows then showed the same address / 0 km distance
              // on the Location Verification screen). 0 = save the candidate's address as a NEW record.
              addressId: 0,
              addLine1: data.address.addLine1 || '',
              addLine2: data.address.addLine2 || '',
              addLine3: data.address.addLine3 || '',
              cityId: data.address.cityId || '',
              districtId: data.address.districtId || '',
              stateId: data.address.stateId || '',
              countryId: data.address.countryId || '',
              postalCode: data.address.postalCode || '',
              locationId: data.address.locationId || '',
              country: data.address.country || '',
              city: data.address.city || '',
              district: data.address.district || '',
              state: data.address.state || '',
              place: data.address.place || '',
            });
            // patchValue alone is NOT enough for State / District-City / Place / Village. <app-address>
            // disables those four controls in its own ngOnInit (countryId is still blank when this form is
            // first built), and their option lists are only loaded by its cascade
            // checkAddress() -> selectcountry()/addressChange(), which runs off the `addressList` input.
            // Writing ids straight into the form left the controls greyed out and blank (empty lists mean
            // displayStateFn/displayDistrictFn return null) AND dropped them from the submit payload,
            // because addressForm.value excludes disabled controls. Handing the data-entry address to
            // address1 runs that cascade - the same way every other screen feeds this control.
            // addressId is deliberately NOT passed: the candidate's address must save as a NEW record.
            this.address1.next({
              addLine1: data.address.addLine1 || '',
              addLine2: data.address.addLine2 || '',
              addLine3: data.address.addLine3 || '',
              postalCode: data.address.postalCode || '',
              countryId: data.address.countryId || '',
              stateId: data.address.stateId || '',
              districtId: data.address.districtId || '',
              cityId: data.address.cityId || '',
              locationId: data.address.locationId || ''
            });
          }
        }
        // Current address: relationship is locked to Self (the note tells the candidate that friends,
        // neighbours and family members are not allowed to do the verification).
        if (!this.isPermanentAddress && this.addressForm) {
          const relCtrl = this.addressForm.get('RelationshipWithTheCandidate');
          if (relCtrl) { relCtrl.setValue('Self'); }
        }
      }
    })
  }
  getUrl() {
    this.route.queryParams.subscribe(par => {
      this.ScrenningComid = par.ScreeningID
    })
  }
  // Updated getLocation accepts a flag for fast vs accurate mode
getLocation(isFastMode: boolean = true) {
  if (!navigator.geolocation) {
    this.showTopCenter('warn', 'Location', 'Geolocation is not supported by your browser.');
    return;
  }
  this.locationLoading = true;
  this.requestLocation(isFastMode);
}

private requestLocation(isFastMode: boolean) {
  // Config selection based on quick loading vs guaranteed deep values
  const options = isFastMode 
    ? { timeout: 3000, maximumAge: 60000, enableHighAccuracy: false } // Fast: 3s timeout, allows up to 1-min old cache
    : { timeout: 15000, maximumAge: 0, enableHighAccuracy: true };     // Accurate: 15s timeout, forces fresh GPS lock

  navigator.geolocation.getCurrentPosition(
    position => {
      this.zone.run(() => {
        this.locationLoading = false;
        this.locationError = '';
        if (this.addressForm) {
          this.addressForm.patchValue({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          });
        }
        this.cdr.detectChanges();
      });
    },
    error => {
      this.zone.run(() => {
        // If Fast Mode timed out or failed, automatically fall back to Accurate mode once
        if (isFastMode) {
          console.warn("Fast geolocation failed or timed out. Retrying with high accuracy...");
          this.requestLocation(false); 
          return;
        }

        this.locationLoading = false;
        if (error.code === 1) {
          this.locationError = 'Location blocked. Click the lock icon in the address bar → Site settings → Location → Allow, then click GET LOCATION.';
        } else if (error.code === 3) {
          this.locationError = 'Location request timed out. Please ensure GPS is active and click GET LOCATION to retry.';
        } else {
          this.locationError = 'Location unavailable. Please check your device settings and click GET LOCATION to retry.';
        }
        this.cdr.detectChanges();
      });
    },
    options
  );
}
  alert(bodytext) {
    this.headerText = 'Alert';
    this.bodyText = bodytext;
    this.dialog.open(this.sucessAlert, {
      width: '320px',
      disableClose: true
    });
  }
  dialogClose() {
    this.dialog.closeAll();
    this.document = []
    this.addressForm.reset()
    this.addressForm.clearValidators()
    this.addressForm.updateValueAndValidity()
    this.resetDynamicValidators()
    this.Housename = ''
    this.signPhotoName = ''
    this.candidatePhotoName = ''
    this.idProffName = ''
    this.canidatePhoto = null;
    this.signPhoto = null;
    this.idProff = null;
    this.uploadHouse = null
    this.capturedImage = null;
    this.router.navigate(['/'])
  }

  clearValue() {
    this.document = []
    this.addressForm.reset()
    this.addressForm.clearValidators()
    this.addressForm.updateValueAndValidity()
    this.resetDynamicValidators()
    this.Housename = ''
    this.signPhotoName = ''
    this.candidatePhotoName = ''
    this.idProffName = ''
    this.canidatePhoto = null;
    this.signPhoto = null;
    this.idProff = null;
    this.uploadHouse = null
    this.capturedImage = null;
    if (this.isCameraOpen) { this.closeCamera(); }
    // this.router.navigate[('')]
  }

  // DAV: relationship-specific + photo-refusal validators are toggled at runtime, so clear them on reset.
  private resetDynamicValidators() {
    ['photoRefusalReason', 'RelationshipSpecification'].forEach(ctrl => {
      const c = this.addressForm.get(ctrl);
      if (c) { c.clearValidators(); c.updateValueAndValidity(); }
    });
  }

  // DAV point 3: permanent-address relationship = "Others" makes the free-text specification mandatory.
  onRelationshipChange(value: string) {
    const specControl = this.addressForm.get('RelationshipSpecification');
    if (!specControl) { return; }
    if (value === 'Others') {
      specControl.setValidators(Validators.required);
    } else {
      specControl.clearValidators();
      specControl.setValue('');
    }
    specControl.updateValueAndValidity();
  }

  // DAV point 7: refusing the selfie makes the reason mandatory and clears any captured photo.
  onPhotoRefuseChange(event: any) {
    const reasonControl = this.addressForm.get('photoRefusalReason');
    if (!reasonControl) { return; }
    if (event.checked) {
      reasonControl.setValidators(Validators.required);
      this.capturedImage = null;
      this.canidatePhoto = null;
      this.candidatePhotoName = '';
      if (this.isCameraOpen) { this.closeCamera(); }
    } else {
      reasonControl.clearValidators();
      reasonControl.setValue('');
    }
    reasonControl.updateValueAndValidity();
  }
  // dateCompare(startdate,endate ){
  //  this.common.dateCompare(startdate,endate,this.addressForm)
  // }

  tillDate(data) {
    if (data.checked == true) {

      this.addressForm.get('toDate').setValue(new Date())
    }
    else {
      this.addressForm.get('toDate').reset()
    }
  }

  //image Crapping
  // rotate(type) {
  //   switch (type) {
  //     case 'right':
  //       this.imageCropper.rotateRight();
  //       break;
  //     case 'left':
  //       this.imageCropper.rotateLeft();
  //       break;
  //     case 'flipHorizontal':
  //       this.imageCropper.flipHorizontal();
  //       break;
  //     case 'flipVertical':
  //       this.imageCropper.flipVertical();
  //       break;
  //     default:
  //       break;
  //   }
  // }
  // imageCropped(event: ImageCroppedEvent) {
  //   this.croppedImage = event.base64;
  //   this.fileData = this.common.convertBase64ToFileObj(this.croppedImage);
  // }
  showTopCenter(level: string, info: string, message: string) {
    this.message.add({ severity: level, summary: info, detail: message });
  }
  //Common Alert
  commonAlert() {
    this.showTopCenter('warn', 'Failure Message',
      'Please upload a valid file,' + ' Acceptable file Formats : .png, .jpg, .JPG, .jpeg, .gif, .psd, .bmp');
  }
  //TodateValidate
  setToDate(fromDate) {

    this.maxDate = fromDate.value
  }

  // See the comment where this is called (submitForm's applicainDetails build) - re-anchors a
  // LOCAL-midnight Date to UTC noon on the same calendar day, so JSON.stringify()'s implicit
  // toISOString() can no longer shift it onto the previous day for timezones ahead of UTC.
  private toUtcNoon(date: any): Date | null {
    if (!date) { return null; }
    const d = new Date(date);
    return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 12, 0, 0));
  }
  // closeTab(){
  //   window.close();
  // }

  async openCamera() {
    this.isCameraOpen = true;
    this.candidatePhotoName = '';
    this.capturedImage = null;

    try {
      this.stream = await navigator.mediaDevices.getUserMedia({ video: true });
      this.video.nativeElement.srcObject = this.stream;
    } catch (err) {
      console.error('Camera access denied or not available:', err);
      alert('Unable to access camera. Please check permissions.');
      this.isCameraOpen = false;
    }
  }

  // captureImage() {
  //   const canvas = document.createElement('canvas');
  //   canvas.width = this.video.nativeElement.videoWidth;
  //   canvas.height = this.video.nativeElement.videoHeight;
  //   const ctx = canvas.getContext('2d');
  //   ctx.drawImage(this.video.nativeElement, 0, 0, canvas.width, canvas.height);
  //   this.capturedImage = canvas.toDataURL('image/png');
  //   this.candidatePhotoName = 'Captured_Selfie.png';

  //   // Automatically close camera after capture
  //   this.closeCamera();
  // }

  captureImage() {
    const canvas = document.createElement('canvas');
    canvas.width = this.video.nativeElement.videoWidth;
    canvas.height = this.video.nativeElement.videoHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(this.video.nativeElement, 0, 0, canvas.width, canvas.height);
    this.capturedImage = canvas.toDataURL('image/png');
    this.candidatePhotoName = 'Captured_Selfie.png';
    // CTS-AC-2710: a fresh capture replaces the "previously uploaded" indicator for this slot.
    this.previousSelfieFileName = '';
    this.previousSelfieUrl = '';
    // Convert canvas to blob (image file)
    canvas.toBlob((blob) => {
      if (blob) {
        const file = new File([blob], 'Captured_Selfie.png', { type: 'image/png' });
        this.canidatePhoto = file;
      }
    }, 'image/png');
    // Automatically close camera after capture
    this.closeCamera();
  }

  closeCamera() {
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      this.stream = null;
    }
    this.isCameraOpen = false;
  }

  // Optional: method to upload image to server
  uploadCapturedImage() {
    if (this.capturedImage) {
      const base64 = this.capturedImage.split(',')[1]; // remove data:image/png;base64,
      // call API here to upload
    }
  }

  removeImageCaptured() {
    this.capturedImage = null;
    this.candidatePhotoName = '';
  }

  // Door photo camera capture - mirrors openCamera/captureImage/closeCamera above, but writes into
  // uploadHouse/Housename (the fields the rest of the form - validation, submit docs array, reset -
  // already reads/writes for the door photo) instead of introducing new submit-pipeline fields.
  // The door is photographed from outside, so the door camera opens on the BACK camera ('environment') by
  // default; Switch Camera flips to the front one and back. Desktops/laptops with a single webcam ignore the
  // preference and use that webcam.
  async openDoorCamera() {
    this.isDoorCameraOpen = true;
    this.Housename = '';
    this.capturedDoorImage = null;
    this.doorFacingMode = 'environment';
    await this.startDoorStream();
  }

  async switchDoorCamera() {
    this.doorFacingMode = this.doorFacingMode === 'environment' ? 'user' : 'environment';
    await this.startDoorStream();
  }

  private async startDoorStream() {
    this.stopDoorStream();
    try {
      try {
        this.doorStream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: { ideal: this.doorFacingMode } }
        });
      } catch (constraintErr) {
        // Some older browsers reject the facingMode constraint outright - fall back to any camera.
        this.doorStream = await navigator.mediaDevices.getUserMedia({ video: true });
      }
      // The <video> sits under *ngIf="isDoorCameraOpen" - render it before attaching the stream.
      this.cdr.detectChanges();
      this.doorVideo.nativeElement.srcObject = this.doorStream;
      // Only offer Switch Camera when the device actually has more than one camera.
      if (navigator.mediaDevices.enumerateDevices) {
        const devices = await navigator.mediaDevices.enumerateDevices();
        this.hasMultipleCameras = devices.filter(d => d.kind === 'videoinput').length > 1;
      }
    } catch (err) {
      console.error('Camera access denied or not available:', err);
      alert('Unable to access camera. Please check permissions.');
      this.isDoorCameraOpen = false;
    }
  }

  private stopDoorStream() {
    if (this.doorStream) {
      this.doorStream.getTracks().forEach(track => track.stop());
      this.doorStream = null;
    }
  }

  captureDoorImage() {
    const canvas = document.createElement('canvas');
    canvas.width = this.doorVideo.nativeElement.videoWidth;
    canvas.height = this.doorVideo.nativeElement.videoHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(this.doorVideo.nativeElement, 0, 0, canvas.width, canvas.height);
    this.capturedDoorImage = canvas.toDataURL('image/png');
    this.Housename = 'Captured_DoorPhoto.png';
    // CTS-AC-2710: a fresh capture replaces the "previously uploaded" indicator for this slot.
    this.previousDoorPhotoFileName = '';
    this.previousDoorPhotoUrl = '';
    canvas.toBlob((blob) => {
      if (blob) {
        this.uploadHouse = new File([blob], 'Captured_DoorPhoto.png', { type: 'image/png' });
      }
    }, 'image/png');
    this.closeDoorCamera();
  }

  closeDoorCamera() {
    this.stopDoorStream();
    this.isDoorCameraOpen = false;
  }

  removeDoorImageCaptured() {
    this.capturedDoorImage = null;
    this.Housename = '';
    this.uploadHouse = '';
  }
}
